import type { MessageInstance } from 'antd/es/message'

type MessageApi = MessageInstance['info'] &
    MessageInstance['error'] &
    MessageInstance['success'] &
    MessageInstance['warning']

const MessageApiKeys = ['info', 'error', 'success', 'warning']

const messageHack = (messageInstance: MessageInstance): void => {
    MessageApiKeys.forEach((key: string) => {
        const origFun: MessageApi = messageInstance[key]
        messageInstance[key] = addKey(origFun)
    })
}

// 强制message添加key，减少频繁操作时满屏的提示
function addKey(origFun: MessageApi): any {
    return (params, ...args) => {
        // fixed：token失效时会出现两个提示，有个没有内容
        if(!params){
            return
        }

        if (typeof params === 'string' && args.length === 0) {
            return origFun({ content: params, key: params })
        }

        return origFun(params)

    }
}

export default { messageHack }
